module.exports = __webpack_public_path__ + "static/media/DownloadIcon.6b3e4ccd.svg";